import React from 'react';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { CrCommandBar } from './CrCommandBar';

export interface IFormCommandBarProps {
    primaryText?: string;
    cancelText?: string;
    hidePrimary?: boolean;
    primaryDisabled?: boolean;
    saving?: boolean;
    onSave: () => void;
    onCancel: () => void;
}

export const FormCommandBar = ({
    primaryText,
    cancelText,
    hidePrimary = false,
    primaryDisabled = false,
    saving = false,
    onSave,
    onCancel
}: IFormCommandBarProps): React.ReactElement => {

    const commandBarItems: ICommandBarItemProps[] = [];

    if (!hidePrimary) {
        commandBarItems.push({
            key: 'save',
            text: saving ? 'Saving...' : (primaryText || 'Save'),
            iconProps: { iconName: saving ? 'Sync' : 'Save' },
            disabled: primaryDisabled || saving,
            onClick: onSave
        });
    }

    commandBarItems.push({
        key: 'cancel',
        text: cancelText || 'Cancel',
        iconProps: { iconName: 'Cancel' },
        disabled: saving,
        onClick: onCancel
    });

    const farCommandBarItems: ICommandBarItemProps[] = [
        { key: 'close', text: 'Close', iconOnly: true, iconProps: { iconName: 'Cancel' }, onClick: onCancel, disabled: saving },
    ];

    return <CrCommandBar items={commandBarItems} farItems={farCommandBarItems} />;
};